import { type INavLinks, type TSectionAnchor } from 'shared/settings/routes';

import { DATA_AS_NAV_TAB_ATTR } from './dataAsNavTabAttr';

export function getNavLinksFromSections(): INavLinks[] {
  const sections = document.querySelectorAll<HTMLElement>(`section[id][${DATA_AS_NAV_TAB_ATTR}]`);

  if (sections.length < 1) {
    return [];
  }

  return Array.from(sections).reduce((accumulator, section) => {
    const id = section.getAttribute('id');
    const title = section.getAttribute(DATA_AS_NAV_TAB_ATTR);

    if (title && id) {
      accumulator.push({
        offsetHeight: section.offsetHeight,
        offsetTop: section.offsetTop,
        title,
        value: id as TSectionAnchor,
      });
    }

    return accumulator;
  }, Array.of<INavLinks>());
}
